export default {
  remove: 'Do you want to remove {msg}',
  toggle: 'Do you want to toggle {msg}',
  update: 'Do you want to update {msg}',
  upgrade: 'Do you want to upgrade {msg}',
  stop: 'Do you want to stop {msg}',
  restart: 'Do you want to restart {msg}',
  reset: 'Do you want to reset {msg}',
  saveBeforeNextPage: 'Save changes before moving to the next page?'
}
